import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/*
 * Pageview tracking for a single-page app.
 *
 * The AngularJS shell relied on gtag's automatic pageview, which only fires
 * on a full document load. Client-side route changes are invisible to it,
 * so every migrated page has to report its own — otherwise the whole app
 * counts as one hit at whatever URL the user first landed on.
 *
 * The tag is configured with send_page_view: false in the shell, so the
 * first load is reported here too rather than twice.
 */
export function usePageViews() {
	const location = useLocation();

	useEffect(() => {
		if (typeof window.gtag !== 'function') return;
		/* GA4 derives the page path from page_location; page_path is a
		 * Universal Analytics field and is ignored here. */
		window.gtag('event', 'page_view', {
			page_location: window.location.href,
			page_title: document.title,
		});
	}, [location.pathname, location.search]);
}
